<template>
    <div 
        class="Mcp_Wheel-loader"
        :class="{
          display: display,
          fixed: fixed
        }"
    >
        <svg
            v-svg
            symbol="Loader"
            :size="`0 0 ${wheelSize} ${wheelSize}`"
            role="presentation"
            class="icon--inline"
        ></svg>
    </div>
</template>

<script>

export default {
    name: "McpWheelLoader",

    props: {
        display: {
            type: Boolean,
            default: false
        },
        fixed: {
          type: Boolean,
          default: true
        },
        wheelSize: {
          type: String,
          default: '80'
        }
    },
}
</script>

<style lang="scss">
.Mcp_Wheel-loader {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 99;
  opacity: 0;
  pointer-events: none;

  // Full page
  &.fixed {
    position: fixed;
  }

  &.display {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
    pointer-events: all;
    svg {
      animation: loaderWheelRollAndScale 3s infinite;
      transform: rotate(30deg);
    }
  }
}

.Mcp_Wheel-loader.display svg {
  fill: #EC3D2D;
}
</style>